import React, { useEffect, useState } from 'react'
import { useOrder } from '../../hooks/useAuth'
import { LegalContact, LegalNav } from './legal-shared.components'
import './terms.styles.scss'

const TermsAndConditions = () => {
  const { curPage } = useOrder()
  const [company, setCompany] = useState(curPage?.company || {})

  useEffect(() => {
    if (curPage?.company) setCompany(curPage.company)
  }, [curPage])

  return (
    <section className="legal-v2">
      <div className="legal-v2__glow legal-v2__glow--a" aria-hidden="true" />
      <div className="legal-v2__glow legal-v2__glow--b" aria-hidden="true" />

      <div className="legal-v2__inner">
        <div className="legal-v2__intro">
          <p className="legal-v2__eyebrow">Policies</p>
          <h1>
            <span className="legal-v2__script">Terms</span>
            <span className="legal-v2__solid">&amp; conditions</span>
          </h1>
          <p className="legal-v2__lead">
            Please read these terms before placing a booking request with Cake by Sandy.
          </p>
          <LegalNav />
        </div>

        <article className="legal-v2__panel">
          <p className="legal-v2__updated">Last updated: July 21, 2026</p>

          <p>
            Welcome to Cake by Sandy. By submitting a booking request or inquiry through our website,
            you agree to the following terms.
          </p>

          <h2>1. General</h2>
          <p>
            These terms apply to booking requests and inquiries made with Cake by Sandy. We may update
            this page from time to time. The version posted here is the one that applies when you
            submit a request.
          </p>

          <h2>2. Booking requests</h2>
          <p>
            Submitting a form on this site is a request, not an instant confirmed order. We review
            availability and details, then confirm with you by phone or email. Custom cakes usually
            need more lead time. We recommend requesting at least one week ahead when you can, and
            longer for complex designs.
          </p>

          <h2>3. Payments</h2>
          <p>
            This website does not collect card payments or process PayPal checkout. Pricing and
            payment method are confirmed with you after we accept your request. A deposit or full
            payment may be required before we begin baking, depending on the order. Do not assume a
            bake is reserved until we confirm it in writing or by phone.
          </p>

          <h2>4. Cancellations and refunds</h2>
          <p>
            Cancellation and refund terms are shared when your order is confirmed. As a guide,
            earlier notice gives us more room to refund deposits. Last-minute cancellations may
            receive a partial refund or none, especially once ingredients have been purchased or
            baking has started. Confirmed details in your order conversation control if they differ
            from this guide.
          </p>

          <h2>5. Delivery and pickup</h2>
          <p>
            Pickup and delivery options are arranged when we confirm your order. Delivery may be
            available within a limited area for an additional fee, subject to schedule. Please provide
            accurate contact and address details. Uncollected pickup orders are the customer&apos;s
            responsibility after the agreed window.
          </p>

          <h2>6. Product quality and storage</h2>
          <p>
            Our cakes and pastries are best enjoyed fresh. Store them as we advise for your specific
            bake. Custom cakes with perishable fillings should usually be refrigerated. We are not
            responsible for quality issues caused by improper storage after pickup or delivery.
          </p>

          <h2>7. Allergies and dietary restrictions</h2>
          <p>
            Tell us about allergies or dietary needs when you request a bake. We take care in the
            kitchen, but we cannot guarantee a completely allergen-free environment or product.
          </p>

          <h2>8. Custom designs</h2>
          <p>
            For custom work, share clear details or reference photos. We aim to match your vision
            closely. Small variations in color, texture, or decoration can still happen with handmade
            baking.
          </p>

          <h2>9. Limitation of liability</h2>
          <p>
            To the fullest extent allowed by law, Cake by Sandy&apos;s liability related to a product
            or service is limited to the amount you paid for that product or service. We are not
            responsible for indirect losses, including event disruption caused by factors outside our
            reasonable control.
          </p>

          <h2>10. Governing law</h2>
          <p>
            These terms are governed by the laws of the place where Cake by Sandy operates. Disputes
            will be handled in the courts of that jurisdiction unless we agree otherwise in writing.
          </p>

          <h2>11. Contact</h2>
          <LegalContact company={company} />

          <p className="legal-v2__thanks">
            Thank you for choosing Cake by Sandy. We look forward to baking for you.
          </p>
        </article>
      </div>
    </section>
  )
}

export default TermsAndConditions
